import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from './website/pages/home';
import About from './website/pages/about';
import Terms from './website/pages/terms';
import Disclaimer from './website/pages/disclaimer';
import PrivacyPolicy from './website/pages/privacypolicy';
import Rooms from './website/pages/rooms';
import RoomList from './website/pages/room-list';
import Services from './website/pages/services';
import Gallery from './website/pages/gallery';
import Contact from './website/pages/contact';
import Banquet from './website/pages/banquet';
import Dinein from './website/pages/dinein';
import Dashboard from './superuser/pages/dashboard';
import RoomCategory from './superuser/pages/RoomCategory';
import RoomAmenities from './superuser/pages/RoomAmenities';
import RoomDetails from './superuser/pages/room-details';
import RoomGallery from './superuser/pages/RoomGallery';
import RoomInventory from './superuser/pages/RoomInventory';
import WebBanner from './superuser/pages/WebBanner';
import PendingsBooking from './superuser/pages/PendingsBooking';
import ConfirmBooking from './superuser/pages/ConfirmBooking';
import Gcategory from './superuser/pages/Gcategory';
import AddGallery from './superuser/pages/AddGallery';
import Feedbacks from './superuser/pages/Feedbacks';
import QuickEnquiry from './superuser/pages/QuickEnquiry';
import ContactEnquiry from './superuser/pages/ContactEnquiry';
import ChangePassword from './superuser/pages/change_password';


import Login from "./superuser/pages/login";
import PrivateRoute from "./routes/PrivateRoute";

import './App.css';
import RoomsCheckout from "./website/pages/rooms-checkout";

function App() {
  return (
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
         <Route path="/terms" element={<Terms />} />
         <Route path="/disclaimer" element={<Disclaimer />} />
         <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/room-list" element={<RoomList />} />
        <Route path="/room-checkout" element={<RoomsCheckout />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
         <Route path="/banquet" element={<Banquet />} />
         <Route path="/dinein" element={<Dinein />} />
         <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /> </PrivateRoute>} />
        <Route path="/RoomCategory" element={<PrivateRoute><RoomCategory /></PrivateRoute>} />
        <Route path="/RoomAmenities" element={<PrivateRoute><RoomAmenities /></PrivateRoute>} />
        <Route path="/room-details" element={<PrivateRoute><RoomDetails /></PrivateRoute>} />
        <Route path="/RoomGallery" element={<PrivateRoute><RoomGallery /></PrivateRoute>} />
        <Route path="/RoomInventory" element={<PrivateRoute><RoomInventory /></PrivateRoute>} />
         <Route path="/WebBanner" element={<PrivateRoute><WebBanner /></PrivateRoute>} />
         <Route path="/PendingsBooking" element={<PrivateRoute><PendingsBooking /></PrivateRoute>} />
        <Route path="/ConfirmBooking" element={<PrivateRoute><ConfirmBooking /></PrivateRoute>} />
        <Route path="/Gcategory" element={<PrivateRoute><Gcategory /></PrivateRoute>} />
        <Route path="/AddGallery" element={<PrivateRoute><AddGallery /></PrivateRoute>} />
        <Route path="/Feedbacks" element={<PrivateRoute><Feedbacks /></PrivateRoute>} />
        <Route path="/QuickEnquiry" element={<PrivateRoute><QuickEnquiry /></PrivateRoute>} />
         <Route path="/changepassword" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
         <Route path="/ContactEnquiry" element={<PrivateRoute><ContactEnquiry /></PrivateRoute>} />
      </Routes>
  );
}

export default App;
